<app-header [label]="page_name | plural"></app-header>
<div class="flex flex-col bg-white gap-4 items-center justify-start p-4">
    <div class="flex justify-between items-center w-full">
        <app-toggle-tabs [tabs]="tabList" [defaultActive]="'unreleased'" [params]="params" params_name="release_status" [value_on_params]="true"></app-toggle-tabs>
    </div>
</div>
<app-ag-grid-list [list]="items" [colDefs]="columns" height="calc(100vh - 250px)" [bulk_delete]="false" [show_checkboxes]="false" [itemName]="page_name" (fetch_new_list)="get_list($event)" (bulkDelete)="bulk_delete($event)" main_description="Results will appear here" description="Please select the dropdown fields to view the results">
    <div filters class="flex gap-4 flex-wrap justify-between items-center w-full">

        <div class="flex gap-4">
            <app-select-input label="School" [depended]="1" class="w-52" [options]="university_options" (valueChange)="onDropdownChange($event)" (registerSelf)="registerDropdown($event)" [(ngModel)]="params.university_id"></app-select-input>
            <app-select-input label="Academic Year" [depended]="2" class="w-52" [options]="academic_year_options" (valueChange)="onDropdownChange($event)" (registerSelf)="registerDropdown($event)" [(ngModel)]="params.academic_year_id"></app-select-input>
            <app-select-input label="Exam Name" [depended]="3" class="w-52" [options]="exam_options" (valueChange)="onDropdownChange($event)" (registerSelf)="registerDropdown($event)" [(ngModel)]="params.exam_id"></app-select-input>
            <app-select-input label="Subject Name" [depended]="4" class="w-52" [options]="assessment_options" (valueChange)="onDropdownChange($event)" (registerSelf)="registerDropdown($event)" [(ngModel)]="params.assessment_id"></app-select-input>
        </div>


        <div class="flex gap-4 items-center">
            <app-search-input #searchbar (valueChange)="get_list({ search: $event, page: 1 })" placeholder="Search by Roll No"></app-search-input>
            <app-button color="bg-white border-primary text-primary" icon="bx bx-download" (click)="items?.count > 0 ? fs.bulk_download(ds, 'get_exam_result_list', bulk_columns, `Exam result`,{assessment_id: params.assessment_id, release_status: params.release_status}) : null"></app-button>
            <app-button *ngIf="this.gs.user_role_data?.exam_results_exam_results_release && params.release_status == 'unreleased'" color="bg-secondary text-[#310000]" [label]="'Publish'" (click)="open_form_modal()"></app-button>
        </div>

        <!-- <app-button color="bg-secondary text-[#310000]" [label]="'View Result'" (click)="open_form_modal()"></app-button> -->
    </div>
</app-ag-grid-list>
<!-- <app-confirmation-popup #confirmation_disabled_modal [enable_icon]="true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to {{selected_ids.is_active == true? "Disable" :"Enable"}} {{page_name}}
</app-confirmation-popup> -->
<app-confirmation-popup #confirmation_disabled_modal [enable_icon]="selected_ids.is_active == true ? false : true" [disabled_icon]="selected_ids.is_active == false ? false : true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" (close_modal_clicked)="confirmation_delete_modal.close()">
    Are you sure you want to {{selected_ids.is_active == true? "Disable" :"Enable"}} {{page_name}}
</app-confirmation-popup>
<app-confirmation-popup #confirmation_delete_modal [delete_icon]="true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" (confirm_modal_clicked)="delete()" (close_modal_clicked)="confirmation_delete_modal.close()">
    Are you sure you want to Permanently delete the selected record ? This cannot be undone
</app-confirmation-popup>
<app-modal #form_modal [label]="`${selected_ids.id ? 'Update' : 'Publish'} Result`">
    <form [formGroup]="form">
        <div class="py-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
            <app-select-input label="School" [depended]="1" class="w-full" [is_required]="true" formControlName="university_id" [options]="university_options" (valueChange)="onModalDropdownChange($event)" (registerSelf)="registerModalDropdown($event)"></app-select-input>
            <app-select-input label="Academic Year" [depended]="2" class="w-full" [is_required]="true" formControlName="academic_year_id" [options]="modal_academic_year_options" (valueChange)="onModalDropdownChange($event)" (registerSelf)="registerModalDropdown($event)"></app-select-input>
            <app-select-input label="Exam Name" [depended]="3" class="w-full sm:col-span-2 lg:col-span-2" [is_required]="true" formControlName="exam_id" [options]="modal_exam_options" (valueChange)="onModalDropdownChange($event)" (registerSelf)="registerModalDropdown($event)"></app-select-input>
            <app-select-input label="Subject Name" [depended]="4" class="w-full sm:col-span-2 lg:col-span-2" [is_required]="true" [is_multiple]="true" formControlName="subject_ids" [options]="modal_assessment_options" (valueChange)="onSubjectSelectionChange($event)"></app-select-input>
        </div>

        <!-- Subjects with Levels Table -->
        <div *ngIf="selected_subjects.length > 0" class="mt-4 mb-4">
            <hr class="border-[#E0E0E0] mb-4" />
            <div class="flex text-[#666666] font-semibold mb-2 px-1">
                <div class="flex-1">Subject Name</div>
                <div class="w-[200px]">Select Level</div>
                <div class="w-8"></div>
            </div>
            <div class="max-h-[250px] overflow-y-auto pr-2 custom-scrollbar">
                <div *ngFor="let subject of selected_subjects; let i = index" class="flex items-center py-2 px-1">
                    <div class="flex-1 text-[#666666] pr-4 truncate">{{ subject.name }}</div>
                    <div class="w-[200px] flex items-center gap-3">
                        <app-select-input class="flex-1" [placeholder]="'Select Level'" [is_required]="true" [(ngModel)]="subject.level" [ngModelOptions]="{standalone: true}" [options]="subject.levels_options" appendTo="body"></app-select-input>
                        <i class="bx bx-x text-2xl text-red-500 cursor-pointer" (click)="removeSubject(subject.id)"></i>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end items-center gap-2 mt-4">
            <app-button color="border-primary text-primary" label="Close" type="button" (click)="close_form_modal()"></app-button>
            <app-button color="bg-[#3F41D1] text-white" [label]="selected_ids.id ? 'Update' : 'Publish'" type="button" [submit]="selected_ids.id ? submit.bind(this) : open_publish_confirmation.bind(this)"></app-button>
        </div>
    </form>
</app-modal>


<app-confirmationdialogcomponent #publish_modal [title]="'Are you sure you want to publish?'" [description]="'This action will publish the result and it cannot be undone'" [confirmText]="'Yes, Publish'" [cancelText]="'No'" (confirmed)="publishResult()">
</app-confirmationdialogcomponent>

<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
    <app-bulk-upload [title]="page_name" [cancel]="bulk_modal" [accepted_type]="['.csv']" [max_file_sizeMB]="5" [bulk_columns]="bulk_columns" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>
<app-modal #view_modal [label]="'View '+ page_name" width="md" (close_modal_clicked)="view_modal.close()">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Subject Name</p>
            <p class="text-gray-900 mt-1">{{ selected_ids?.subject_name || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Roll No</p>
            <p class="text-gray-900 mt-1">{{ selected_ids?.barcode || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Script ID</p>
            <p class="text-gray-900 mt-1">{{ selected_ids?.script_id || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">Total Marks</p>
            <p class="text-gray-900 mt-1">{{ selected_ids?.total_marks || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">AI Score</p>
            <p class="text-gray-900 mt-1">{{ selected_ids?.ai_score || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">L1 Marks</p>
            <p class="text-gray-900 mt-1">{{ selected_ids?.l1_marks || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">L2 Marks</p>
            <p class="text-gray-900 mt-1">{{ selected_ids?.l2_marks || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">L3 Marks</p>
            <p class="text-gray-900 mt-1">{{ selected_ids?.l3_marks || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">L4 Marks</p>
            <p class="text-gray-900 mt-1">{{ selected_ids?.l4_marks || '—' }}</p>
        </div>
        <div class="p-2 break-words">
            <p class="font-semibold text-gray-700">HE Marks</p>
            <p class="text-gray-900 mt-1">{{ selected_ids?.he_marks || '—' }}</p>
        </div>
    </div>
</app-modal>